import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Paper from 'components/atoms/Papers/Paper/Paper';
import utils from 'helpers/utils';

const StyledInfoPaper = styled(Paper)
  .attrs((props) => {
    let attr = props;

    const vars = {
      '--info-paper-background-color': props.theme.property(`palette.${props.$color}.states.selected`)
    };

    return utils.styleProps(attr, vars);
  })`
  &.InfoPaper {
    display: flex;
    position: relative;
    padding: ${props => props.theme.spacing(1)};
    border: 1px solid ${props => props.theme.property('palette.divider')};
    border-radius: ${props => props.theme.radius(1)};
    background-color: ${props => props.$css.$var('--info-paper-background-color')};
  }
  
  .InfoPaper {
    &-icon {
      margin-right: ${props => props.theme.spacing(0.5)};
    }

    &-info {
      .Typography {
        white-space: normal;  
      }
    }

    &-action {
      position: absolute;
      top: ${props => props.theme.spacing(0.5)};
      right: ${props => props.theme.spacing(0.5)};
    }
  }
  
  &.InfoPaper-radius-round {
    border-radius: ${props => props.theme.radius(2)};
  }
  
  ${ComponentStyles}
`;

StyledInfoPaper.propTypes = {
  theme: PropTypes.object
};

export default StyledInfoPaper;
